// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__0zaXN","btnOffer":"AddProduct_btnOffer__RBJPY"};